module.exports = __webpack_public_path__ + "img/coastal.fa250657.svg";